




























import { Component, Prop, Vue } from 'vue-property-decorator'
import { Question } from '@/views/Form/Conversation.vue'
import Message from '@/views/Form/Conversation/Message.vue'

@Component({
    components: {
        Message,
    },
})
export default class ChatPanel extends Vue {
    @Prop() questions!: Question[]
    @Prop() answers!: any
    @Prop() activeQuestionIndex!: number
    @Prop() activeQuestion!: Question|null
    @Prop({type: Boolean, default: false}) typing!: boolean

    get renderedQuestions(): Question[] {
        // Add empty question for typing after final question
        const questions = [].concat(this.questions, [{
            question: '',
        }])

        return questions.reverse()
    }

    convertQuestionIndex(questionIndex: number): number {
        return this.renderedQuestions.length - questionIndex - 1
    }

    isActiveQuestion(questionIndex: number): boolean {
        return this.activeQuestionIndex === this.convertQuestionIndex(questionIndex)
    }

    isQuestionVisible(questionIndex: number): boolean {
        return this.activeQuestionIndex >= this.convertQuestionIndex(questionIndex)
    }

    hasAnswer(question: Question): boolean {
        if (!question.model || this.answers[question.model] === undefined || this.answers[question.model] === null) {
            return false
        }

        return true
    }

    getAnswer(question: Question): string {
        if (!this.hasAnswer(question)) {
            return null
        }

        const answer = this.answers[question.model]
        if (answer instanceof Array) {
            // Format array of answers
            return answer
                .map(answerItem => this.formatAnswer(question, answerItem))
                .join(', ')
        } else {
            // Format answer
            return this.formatAnswer(question, answer)
        }
    }

    formatAnswer(question: Question, answer: any): string {
        // Convert answer using choices
        if (question.choices && question.choices[answer]) {
            return question.choices[answer]
        }

        // Convert answer using choices from input options
        if (question.inputAttrs && question.inputAttrs.options && question.inputAttrs.options instanceof Array) {
            for (const option of question.inputAttrs.options) {
                if (option.value === answer) {
                    return option.label
                }
            }
        }

        if (question.formatAnswer && typeof answer === 'string') {
            return question.formatAnswer(answer, question)
        }

        return answer
    }
}
